import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.admin.as.list');
import { OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-afterservice-admin-as-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.afterservice.admin.as.list/view.scss */
/* src/app/portal.afterservice.admin.as.list/view.scss: no such file or directory */`],
})
export class PortalAfterserviceAdminAsListComponent implements OnInit {

    @Input() title: any;

    search: any = {
        text: '',
        page_pre: 1,
        page_ing: 1,
        page_done: 1
    };

    list_pre: any[] = [];
    list_ing: any[] = [];
    list_done: any[] = [];

    facet_pre: any = { lastpage: 1 };
    facet_ing: any = { lastpage: 1 };
    facet_done: any = { lastpage: 1 };

    public loading: boolean = false;

    constructor(@Inject( Service)         public service: Service,@Inject( Title)         private titleService: Title,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        await this.service.init();
        this.titleService.setTitle('A/S 관리');

        await this.load();
        await this.service.render();
    }

    async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('search', { ...this.search });
        if (code !== 200) {
            this.loading = false;
            await this.service.render();
            return;
        }

        this.list_pre = data.pre?.list ?? [];
        this.list_ing = data.ing?.list ?? [];
        this.list_done = data.done?.list ?? [];

        this.facet_pre.lastpage = data.pre?.lastpage ?? 1;
        this.facet_ing.lastpage = data.ing?.lastpage ?? 1;
        this.facet_done.lastpage = data.done?.lastpage ?? 1;

        this.loading = false;
        await this.service.render();
    }

    async searchSubmit() {
        this.search.page_pre = 1;
        this.search.page_ing = 1;
        this.search.page_done = 1;
        await this.load();
    }

    onPagePre = async (page: number) => {
        this.search.page_pre = page;
        await this.load();
    }

    onPageIng = async (page: number) => {
        this.search.page_ing = page;
        await this.load();
    }

    onPageDone = async (page: number) => {
        this.search.page_done = page;
        await this.load();
    }

    goView(id: string) {
        this.router.navigate(['/admin/as/view', id]);
    }
}

export default PortalAfterserviceAdminAsListComponent;